export const ACCOUNT_INFO = 'account-information';
export const THANK_YOU = '/thank-you';
export const APPLICATION_ERROR = '/application-error';
export const PHONE_NUMBER_VERIFICATION = 'existing-user-verification';
export const COUNTRY_LIST = [
    {
        label: 'United States',
        value: 'US'
    },
    {
        label: 'Canada',
        value: 'CA'
    }
];
export const COUNTRY = 'country';
export const SELECT_COUNTRY = 'Select Country';
export const ADDRESS = 'address';
export const ADDRESS2 = 'address2';
export const CITY = 'city';
export const STATE = 'state';
export const SELECT_STATE = 'Select State';
export const SELECT_PROVINCE = 'Select Province';
export const ZIP_CODE = 'zipCode';
export const IS_AGREE = 'isAgree';
export const IS_SMS_OPTIN = 'isSmsOptin';
export const IS_PRIVACY_POLICY = 'isPrivacyPolicy';
export const IS_ELECTRONIC_MESSAGE = 'isConsent';
export const DRIVERS_LICENSE_STATE = 'driversLicenseState';
export const DRIVERS_LICENSE_NUMBER = 'driversLicenseNumber';
export const STEP_NAMES = ['personal-information', 'account-information'];
export const STEP_TITLES = ['Personal information', 'Account information'];

export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const MOBILE_NUMBER = 'mobileNumber';
export const DATE_OF_BIRTH = 'dateOfBirth';
export const PASSWORD = 'password';
export const AUTH_USERS = 'authorizedUsers';
export const ZERO = 0;
export const ONE = 1;
export const TWO = 2;
export const THREE = 3;
export const FOUR = 4;
export const FIVE = 5;
export const SIX = 6;
export const SEVEN = 7;
export const EIGHT = 8;
export const TEN = 10;
export const TWELVE = 12;
export const MIN_AGE_LIMIT = 18;
export const DATE_FORMAT = 'MM/dd/yyyy';

export const YES = 'Yes';
export const NO = 'No';
export const ALPHANUMERIC_REGEX = /[^A-Z0-9]/g;
export const AEM_CONTAINS_EMAIL = '#mailid';
export const CHANNEL = 'WEBAPP';
export const NON_CREDIT = 'noncredit';
export const CREATE_ACCOUNT_DATE_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSSSSSSZ';
